import React, { Component } from "react";
import { Button, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  downloadAgendaBriefAction,
  downloadMinuteAction
} from "../../actions/mom.action";
import { get } from "lodash";
import { toast } from "react-toastify";
import { ERROR_MSG } from "../../constant";
import { LoaderPage } from "../Loader";
import { successToastStyle, errorToastStyle } from "../../customToast";

export class DownloadAgendaByType extends Component {
  state = {
    showLoader: false,
    detailedAgenda: false
  };

  onChangeDetailedAgenda = () => {
    this.setState(prevState => ({
      detailedAgenda: !prevState.detailedAgenda
    }));
  };

  downloadAgenda = id => {
    const { detailedAgenda } = this.state;
    detailedAgenda ? this.downloadAgendaAPI(id) : this.downloadAgendaBrief(id);
  };

  downloadAgendaAPI = async id => {
    this.setState({ showLoader: true });
    const resp = await downloadMinuteAction(undefined, id);
    //console.log(resp);
    //return;
    if (resp) {
      const { status, data } = resp;
      if (status && data) {
        this.setState({ showLoader: false });
        toast.success(
          <p className="toast-text-alignment">{ERROR_MSG.DOWNLOAD_SUCCESS}</p>,
          successToastStyle
        );
        window.location.href = get(data, "data");
      } else {
        this.setState({ showLoader: true });
        toast.error(
          <p className="toast-text-alignment">{ERROR_MSG.INVALID_LINK}</p>,
          errorToastStyle
        );
      }
    } else {
      this.setState({ showLoader: true });
      toast.error(
        <p className="toast-text-alignment">{ERROR_MSG.INVALID_LINK}</p>,
        errorToastStyle
      );
    }
  };

  downloadAgendaBrief = async id => {
    this.setState({ showLoader: true });

    const resp = await downloadAgendaBriefAction(undefined, id);

    if (resp) {
      const { status, data } = resp;
      //console.log(status, data);
      //return;
      if (status && data) {
        if (data.status) {
          this.setState({ showLoader: false });
          window.location.href = get(data, "data");
          toast.success(
            <p className="toast-text-alignment">
              {ERROR_MSG.DOWNLOAD_SUCCESS}
            </p>,
            successToastStyle
          );
        } else {
          this.setState({ showLoader: true });
          toast.error(
            <p className="toast-text-alignment">{ERROR_MSG.INVALID_LINK}</p>,
            errorToastStyle
          );
          this.setState({ showLoader: false });
        }
      } else {
        //console.log("status: false", resp);
        //return;
        this.setState({ showLoader: true });
        toast.error(
          <p className="toast-text-alignment">{ERROR_MSG.INVALID_LINK}</p>,
          errorToastStyle
        );
      }
    } else {
      this.setState({ showLoader: true });
      toast.error(
        <p className="toast-text-alignment">{ERROR_MSG.INVALID_LINK}</p>,
        errorToastStyle
      );
    }
  };

  render() {
    const { id } = this.props;
    const { showLoader } = this.state;
    return (
      <React.Fragment>
        <LoaderPage loading={showLoader} />
        <div className="">
          <Form.Check
            type="checkbox"
            label="Download Detailed Agenda"
            className="download-check-box"
            onChange={() => {
              this.onChangeDetailedAgenda();
            }}
          />
          <OverlayTrigger
            overlay={
              <Tooltip
                id="tooltip-pdf"
                className={`agenda-doc-tooltip ${""}`}
                arrowProps={{ variant: false }}
              >
                {"Download Brief Agenda"}
              </Tooltip>
            }
          >
            <span class="download-excel-component  ">
              <span onClick={() => this.downloadAgenda(id)}>
                <span class="doc-icon" />
              </span>
            </span>
          </OverlayTrigger>
        </div>
      </React.Fragment>
    );
  }
}

export default DownloadAgendaByType;
